import { render, staticRenderFns } from "./multiplePermissions.vue?vue&type=template&id=08c287e0&scoped=true"
import script from "./multiplePermissions.vue?vue&type=script&lang=js"
export * from "./multiplePermissions.vue?vue&type=script&lang=js"
import style0 from "./multiplePermissions.vue?vue&type=style&index=0&id=08c287e0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c287e0",
  null
  
)

export default component.exports